import common from "./common";
import details from "./details";
import delivery from "./delivery";
import contact from "./contact";
import payment from "./payment";
import account from "./account";
import quote from "./quote";

// Every checkout text, by language. Each step keeps its own file; keys are
// prefixed with the step ("details.", "delivery.", ...) so they can't clash.
const groups = [common, details, delivery, contact, payment, account, quote];

export const strings = {
  en: Object.assign({}, ...groups.map((group) => group.en)),
  es: Object.assign({}, ...groups.map((group) => group.es)),
  pt: Object.assign({}, ...groups.map((group) => group.pt)),
};
